// this file is automatically generated by pre-build.ts script
export const versions = {"version":"1.0.0","revision":"3926fbf","branch":"HEAD"}